import { useEffect, useState } from 'react';

export const useAllowedFonts = () => {
  const [fontsJson, setFontsJson] = useState<string[] | null>(null);

  useEffect(() => {
    import('@/assets/fonts.json').then((mod) => {
      setFontsJson(mod.default);
    });
  }, []);

  return fontsJson;
};
